<template>
  <div class="company-card" @click="handleym">
    <!-- 标题区域 -->
    <div class="card-header">
      <div class="header-left">
        <span class="icon-box"></span>
        <h3>{{ title }}</h3>
      </div>
      <!-- 模拟右侧的装饰条纹 -->
      <div class="header-decoration"></div>
    </div>

    <!-- 内容区域 -->
    <div class="card-body">
      <p>{{ content }}</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CompanyItem',
  computed: {
    clickoutside() {
      return clickoutside
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleym(){
      this.$root.$emit('resetBanner', { bannerActive1: null, bannerActive: 0 })
      this.$router.push({
        path: "/ordinaryUser/rent" + `?tabKey=${this.id}`
      })
    }
  }
};
</script>

<style scoped>
.company-card {
  background-color: #fff;
  margin-bottom: 20px;
  border: 1px solid #e1adad;
  border-radius: 10px;
  position: relative;
  padding-top: 30px;
}

.card-header {
  width: 400px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  background-image: url("../../assets/image/标题.png");
  background-size: 100% 100%;
  position: absolute;
  top: -10px;
  z-index: 10;
}

.header-left {
  display: flex;
  align-items: center;
  width: 80%;
  span{
    width: 20px;
    height: 20px;
    background-image: url("../../assets/image/icon1.png");
    background-size: 100% 100%;
  }
}
/*
.icon-box {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: #fff;  白色小方块图标
  margin-right: 10px;
  opacity: 0.8;
}*/

.card-header h3 {
  color: #fff;
  font-size: 16px;
  margin-left: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}

/* 模拟标题右侧的白色竖线装饰 */
.header-decoration {
  width: 30px;
  height: 20px;
  background-image: url("../../assets/image/icon2.png");
  background-size: 100% 100%;
}
/*
.header-decoration::before {
  content: '';
  display: block;
  width: 2px;
  height: 14px;
  box-shadow:
    6px 0 0 #fff,
    12px 0 0 #fff,
    18px 0 0 #fff,
    24px 0 0 #fff;
}*/


.card-body {
  padding: 15px 20px;
  color: #666;
  font-size: 13px;
  line-height: 1.6;
  text-align: justify;
}
</style>
